/**
 * @flow
 */

import React from 'react'
import { SkewComponentContainer, SkewText } from './styledComponents'

class SkewComponent extends React.Component<Props> {
  render() {
    const { innerText } = this.props
    return (
      <SkewComponentContainer>
        <SkewText>{innerText}</SkewText>
      </SkewComponentContainer>
    )
  }
}

export default SkewComponent



// WEBPACK FOOTER //
// ./src/components/IbcArcade/SkewComponent/index.js